import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import PLATFORMS from '@appscore/web-constants/platforms';

import useOnce from '@hooks/useOnce';

const LOGO_COLORS = { default: 'red', white: 'white' };

function Logo({ color = LOGO_COLORS.default, className }) {
  const [src, setSrc] = useState(null);

  useOnce(() => {
    const fileName = `${PLATFORMS.pedidosya.key}_${color}`;
    let mounted = true;
    import(`./assets/${fileName}.svg`).then(({ default: logo }) => {
      if (mounted) setSrc(logo);
    });
    return () => {
      mounted = false;
    };
  });

  if (!src) return null;
  return <img className={className} src={src} alt="logo" />;
}

Logo.propTypes = {
  className: PropTypes.string.isRequired,
  color: PropTypes.oneOf([LOGO_COLORS.default, LOGO_COLORS.white]),
};

export { LOGO_COLORS };
export default styled(Logo)``;
